import React from 'react'
import { Modal } from 'react-bootstrap'
import ProgressiveProgressBar from '../ProgressiveProgressBar'
import { useSwipeClose } from '../../hooks/useSwipeClose';

const ProgressModalMobile = ({ show, onHide, message, description, active = true }) => {
    const swipeRef = useSwipeClose(show, onHide);
    return (
        <>
            <Modal
                id="popup-trade-confirm"
                className="round new-modal-style progress-modal-mobile"
                show={show}
                onHide={onHide}
                backdrop="static"
                keyboard={false}
                centered
                animation={false}
            >
                <Modal.Header ref={swipeRef} onClick={onHide}>
                    <div className="close-div"></div>
                </Modal.Header>
                <Modal.Body>
                    <div className="maincontent">
                        <h4 className="m-0">{message}</h4>
                        <p className="paraplacing">
                            {description || 'Please wait while your trade is being processed'}
                        </p>
                        <ProgressiveProgressBar active={active} />

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ProgressModalMobile
